/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/partials/light-box.scss';

const propTypes = {
    opened: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    opened: false,
    onClick: null,
    className: null,
};

const LightBox = ({ opened, onClick, className }) => (
    <button
        type="button"
        onClick={onClick}
        className={classNames([
            styles.container,
            {
                [styles.opened]: opened,
                [className]: className !== null,
            },
        ])}
    />
);

LightBox.propTypes = propTypes;
LightBox.defaultProps = defaultProps;

export default LightBox;
